import { useMsal, useAccount } from "@azure/msal-react";
import { useCallback, useMemo } from 'react';

const scope = process.env.REACT_APP_SCOPE;

export const useToken = () => {

    const { accounts, instance } = useMsal();
    const account = useAccount(accounts[0] || {})
    const tokenRequest = useMemo(() => ({
        scopes: [scope],
        account,
    }), [account]);

    const getTokenSilent = useCallback(async() => {
        const {accessToken} = await instance.acquireTokenSilent(tokenRequest)

        return accessToken
    }, [instance, tokenRequest])

    return {
        tokenRequest,
        getTokenSilent
    }

}
